import React, { Component } from 'react';

class LoadingSpinner extends Component {
    render() {
        return (
            <div className="text-center">
                <i className="fa fa-cog fa-spin fa-5x"></i>
                <h4>Loading...</h4>
            </div>
        );
    }
}

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./src/components/Utilities/LoadingSpinner.js